module.exports = __webpack_public_path__ + "img/tablet-elbow-3_70x74.4558962f.png";